/**
 * getAccountLightApi.js
 *
 * Provides an API call to fetch a lightweight version of account data.
 * Used in self-care to get basic account information without full details.
 *
 * Exports:
 * - getAccountLight: Fetches basic account information.
 */

import { postWithData } from "../shared/apiPatterns";

/**
 * Fetches basic account information.
 *
 * @param {Object} payload - The request payload.
 * @returns {Promise<Object|null>} The API response JSON, or null on error.
 */
export const getAccountLight = (payload) =>
  postWithData("/get-account-light", { ...payload });
